import { useState } from "react"
import { Box, Button, Link, Stack, Typography } from "@mui/material"
import { PORTFOLIO_PROJECTS } from "./projects"

export function WorkNav() {
  const [open, setOpen] = useState(false)

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        left: 16,
        zIndex: 5,
        pointerEvents: "auto",
      }}
    >
      <Button
        size="small"
        aria-expanded={open}
        aria-controls="work-nav-menu"
        onClick={() => setOpen((v) => !v)}
        sx={{
          letterSpacing: "0.18em",
          fontSize: "0.68rem",
          fontWeight: 700,
          color: "rgba(200,220,255,0.9)",
          border: "1px solid rgba(140,170,210,0.35)",
          bgcolor: "rgba(4,8,18,0.55)",
          backdropFilter: "blur(8px)",
          px: 1.5,
        }}
      >
        WORK
      </Button>
      {open ? (
        <Stack
          id="work-nav-menu"
          spacing={0.75}
          sx={{
            mt: 1,
            p: 1.25,
            minWidth: 220,
            border: "1px solid rgba(140,190,255,0.28)",
            bgcolor: "rgba(4,8,18,0.82)",
            backdropFilter: "blur(12px)",
          }}
        >
          {PORTFOLIO_PROJECTS.map((p) => (
            <Link
              key={p.id}
              href={`#${p.anchor}`}
              underline="hover"
              onClick={() => setOpen(false)}
              sx={{
                color: "rgba(220,230,255,0.9)",
                fontSize: "0.78rem",
                letterSpacing: "0.04em",
              }}
            >
              {p.title}
            </Link>
          ))}
          <Typography
            sx={{
              pt: 0.5,
              fontSize: "0.58rem",
              letterSpacing: "0.14em",
              color: "rgba(160,190,230,0.45)",
            }}
          >
            SELECTED WORK
          </Typography>
        </Stack>
      ) : null}
    </Box>
  )
}
